import globalDomains from '@/utils/global-domains';
import ApiCore from '@/api/index';

// event domain 으로 만든 api, eventapi.sooplive.co.kr
const EventApi = ApiCore(globalDomains.EVENTAPI_AFREECATV);
export default EventApi;
